import privileges from '@ubeya/shared-web/privileges';
import { LEGENDS_US_ORGANIZATION_ID } from '@ubeya/shared/utils/accounts';
import { TIME_RANGE_KEY_OPTIONS } from './constants';

export const CREATE_NEW_MAIN_EVENT_PRIVILEGES = [privileges.MANAGE_MAIN_PROJECTS];

export const ASSIGN_MAIN_EVENT_PRIVILEGES = [privileges.ASSIGN_EVENTS_TO_MAIN_PROJECT];

export function userCanCreateNewMainEvent(myPrivileges) {
  return CREATE_NEW_MAIN_EVENT_PRIVILEGES.every((p) => !!myPrivileges?.[p]);
}

export function userCanAssignMainEvent(myPrivileges) {
  return ASSIGN_MAIN_EVENT_PRIVILEGES.every((p) => !!myPrivileges?.[p]);
}

export function isCreateNewMainEventContextMenuVisible({ showAllBranches, isMobileOnly, timeRangeKey }) {
  return !showAllBranches && !isMobileOnly && timeRangeKey === TIME_RANGE_KEY_OPTIONS.MONTHLY;
}

export function isCreateNewMainEventHeaderButtonVisible({
  showAllBranches,
  isMobileOnly,
  timeRangeKey,
  organizationId,
  myPrivileges
}) {
  return (
    isCreateNewMainEventContextMenuVisible({ showAllBranches, isMobileOnly, timeRangeKey }) &&
    organizationId === LEGENDS_US_ORGANIZATION_ID &&
    userCanCreateNewMainEvent(myPrivileges)
  );
}
